import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../CSS/YamlViewer.css";

const YamlViewer = () => {
  const { projectId } = useParams();
  const [yamlContent, setYamlContent] = useState("");
  const [error, setError] = useState(null);
  const [projectName, setProjectName] = useState("");

  useEffect(() => {
    // Fetch YAML content
    fetch(
      `http://localhost:2011/api/definition/project/${projectId}/openapi.yaml`
    )
      .then((res) => {
        if (!res.ok)
          throw new Error("There is no API in Project so Fail to fetch YAML");
        return res.text();
      })
      .then((data) => setYamlContent(data))
      .catch((err) => setError(err.message));

    // Fetch project name
    fetch(`http://localhost:2011/api/projects/${projectId}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch project name");
        return res.json();
      })
      .then((data) => {
        setProjectName(data.name || "Unknown Project");
      })
      .catch((err) => {
        console.error("Error fetching project name:", err);
        setProjectName("Unknown Project");
      });
  }, [projectId]);

  const handleCopy = () => {
    navigator.clipboard.writeText(yamlContent).then(() => {
      alert("YAML copied to clipboard!");
    });
  };

  const handleOpenSwaggerEditor = () => {
    navigator.clipboard.writeText(yamlContent).then(() => {
      window.open("https://editor.swagger.io/", "_black");
    });
  };

  return (
    <div className="yaml-viewer-container">
      <aside className="yaml-sidebar">
        <h2>{projectName}</h2>
      </aside>

      <main className="yaml-content">
        {error ? (
          <div className="error">{error}</div>
        ) : (
          <div className="yaml-box">
            <div className="yaml-box-header">
              <button className="copy-button" onClick={handleCopy}>
                Copy YAML
              </button>

              {/* Tooltip wrapper for Swagger button */}
              <div className="tooltip-container">
                <button
                  className="swagger-button"
                  onClick={handleOpenSwaggerEditor}
                >
                  Open in Swagger Editor
                </button>
                <span className="tooltip-text">
                  Copy this YAML file and click this button.
                  <br />
                  Then paste it in Swagger Editor for API documentation.
                </span>
              </div>
            </div>

            <pre>
              <code className="yaml-code">{yamlContent}</code>
            </pre>
          </div>
        )}
      </main>
    </div>
  );
};

export default YamlViewer;
